import { Footer } from '@/atoms/Text'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'

interface ExpressInterestDisclosureProps {
  theme?: 'dark' | 'light'
}

export const ExpressInterestDisclosure: React.FC<ExpressInterestDisclosureProps> = ({ theme = 'light' }) => {
  const { t } = useTranslate('torches')
  const { query } = useSafeRouter()

  const disclosure = t(
    'disclosure',
    `*No money or other consideration is being solicited, and if sent in response, will not be accepted. No offer to buy the securities can be accepted and no part of the purchase price can be received until the offering statement is filed and only through an intermediary's platform. A person's indication of interest involves no obligation or commitment of any kind.`,
  )
  const angelRegADisclosure = t(
    'angelRegADisclosure',
    `Disclosure: Angel Studios, Inc. is “testing the waters” to gauge investor interest in an offering of securities. No money or other consideration is being solicited, and if sent in response, will not be accepted. No offer to buy the securities can be accepted and no part of the purchase price can be received until the offering statement is qualified. Any such offer may be withdrawn or revoked, without obligation or commitment of any kind, at any time before notice of its acceptance is given after the qualification date. A person's indication of interest involves no obligation or commitment of any kind.`,
  )

  return (
    <Footer color={theme === 'light' ? 'core-gray-700' : 'white'}>
      {query.torch === 'angel-2' ? angelRegADisclosure : disclosure}
    </Footer>
  )
}
